import React from "react";
import { DialogActions } from "@material-ui/core";
import { CloudUploadRounded } from "@material-ui/icons";
import { PrimaryButton, RegularButton, WithTooltip } from "@components";
import locale from "@bonliva-crm/locale";

type Props = {
  canSubmit?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  submitTooltip?: string;
};

export const InitialActions: React.FC<Props> = (props) => {
  return (
    <DialogActions>
      <RegularButton onClick={props.onClose}>{locale.Cancel}</RegularButton>

      <WithTooltip title={props.submitTooltip} placement="top">
        <PrimaryButton
          disabled={!props.canSubmit}
          leftIcon={<CloudUploadRounded />}
          onClick={props.onSubmit}
          style={{ pointerEvents: "auto" }} // needed for tooltip to work!
          type="submit"
        >
          {locale.UploadFile}
        </PrimaryButton>
      </WithTooltip>
    </DialogActions>
  );
};
